export enum EffectType {
  sunlight = 0,
  rain = 1,
}

export enum EffectRainType {
  custom = 0,
  rain = 1,
  snow = 2,
  snowFlower = 3,
  bubble = 4,
  star = 5,
  smile = 6,
  heart = 7,
  packet = 8,
  money = 9,
}

export type SceneEffect = EffectSunlight | EffectRain;

export type EffectSunlight = {
  type: EffectType.sunlight;
  id: string;
  style:
    | 'blinkstyle1'
    | 'blinkstyle2'
    | 'blinkstyle3'
    | 'blinkstyle4'
    | 'blinkstyle5'
    | 'blinkstyle6'
    | 'blinkstyle7'
    | 'blinkstyle8'
    | 'blinkstyle9'; // 光晕风格, 必填, 'blinkstyle1' - 'blinkstyle9'
  ath: number;
  atv: number;
};

export type EffectRain = {
  type: EffectType.rain;
  id: string;
  rainType: EffectRainType;
  mediaId?: number; // 0 为系统图片
  mediaUrl?: string; // rainType = 0 时，使用自定义图片
  scale: number; // 特效缩放，范围0.2-1，默认0.5
  flakes: number; // 雨/雪数量,默认4000
  floor: number; // 地面高度,0-1,默认 0.3
  speed: number; // 下落速度,默认1.0
  shake: number; // 雪花随机振动,默认4.0
  speedVariance: number; // 下降速度随机变化, 默认2.0
  wind: number; // 风力,可改变雪花下降方向, 默认0.0
  windDir: number; // 风力方向, 0-360
  invert: number; // 运动方向 1上升 0下降, 默认 0,
};
